// Cross-sell Tracking SDK Types

/**
 * APP KEY 枚举
 */
export enum CROSS_SELL_APP_KEY {
  PARCEL_PANEL = "5crtj8wVLilMPO2W4m25bq13EeoSlL6g",
  RETURN = "HILSZlKlWgM4zhk1GYjawvijNn0Eab9z",
}

/**
 * 跳转URL参数接口
 */
export interface GetRedirectUrlParams {
  target_app: string  // 目标应用
  location_uuid: string
  trace_id?: string
  redirect_url: string  // 重定向URL
  baseUrl?: string  // 新增：允许自定义基础URL（保留向后兼容）
}

/**
 * 环境配置
 */
export interface CrossSellEnvironment {
  test: "cross-sell-test.parcelpanel.com"
  production: "cross-sell.parcelwill.net"
}

/**
 * SDK配置接口
 */
export interface CrossSellConfig {
  apiKey: CROSS_SELL_APP_KEY
  environment?: "test" | "production"
  enableLogging?: boolean
}

/**
 * APP初始化请求参数 - 通用的键值对结构，支持任意参数
 */
export interface InitAppRequest {
  shopify_id: number
  user_id: number
  domain: string
  plan: string
  shopify_version: string
  [key: string]: any
}

/**
 * APP初始化响应
 */
export interface InitAppResponse {
  code: number
  msg: string
  data: {
    trace_id: string
  }
}

/**
 * 事件类型枚举
 */
export type EventType = "viewed" | "clicked" | "installed" | "subscribed" | "published"

/**
 * 事件上报请求参数
 */
export interface LogEventRequest {
  location_uuid?: string
  event: EventType
  plan_name?: string
  plan_price?: string | number
  source_trace_id?: string
}

/**
 * 事件上报响应
 */
export interface LogEventResponse {
  code: number
  msg: string
  data: Record<string, any>
}

/**
 * API响应基础接口
 */
export interface ApiResponse<T = any> {
  code: number
  msg: string
  data: T
}

/**
 * 错误信息接口
 */
export interface CrossSellError {
  message: string
  code?: number
  originalError?: any
}

/**
 * 事件类型常量
 */
export const EVENT_TYPES = {
  VIEWED: "viewed",
  CLICKED: "clicked",
  INSTALLED: "installed",
  SUBSCRIBED: "subscribed",
  PUBLISHED: "published",
} as const

/**
 * 联系类型枚举
 */
export type ContactType = "WhatsApp" | "Slack" | "WeCom" | "Demo"

/**
 * 来源类型枚举
 */
export type SourceType = "app" | "email"

/**
 * Contact Cross Sell 跳转参数接口
 */
export interface GetContactRedirectUrlParams {
  location_uuid: string
  source?: SourceType  // 可选参数，默认为 "app"
  contact_type: ContactType
  redirect_url: string
  trace_id?: string
}

/**
 * Contact 类型常量
 */
export const CONTACT_TYPES = {
  WHATS_APP: "WhatsApp",
  SLACK: "Slack",
  WE_COM: "WeCom",
  DEMO: "Demo",
} as const

/**
 * 来源类型常量
 */
export const SOURCE_TYPES = {
  APP: "app",
  EMAIL: "email",
} as const
